var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBifamiliare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6664_31174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6664_31174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 18V10.825C2 10.5583 2.05 10.3042 2.15 10.0625C2.25 9.82083 2.39167 9.60833 2.575 9.425L6.575 5.425C6.775 5.225 7 5.075 7.25 4.975C7.5 4.875 7.75 4.825 8 4.825C8.25 4.825 8.5 4.875 8.75 4.975C9 5.075 9.225 5.225 9.425 5.425L13.425 9.425C13.6083 9.60833 13.75 9.82083 13.85 10.0625C13.95 10.3042 14 10.5583 14 10.825V18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18ZM4 18H7V16C7 15.7167 7.09583 15.4792 7.2875 15.2875C7.47917 15.0958 7.71667 15 8 15C8.28333 15 8.52083 15.0958 8.7125 15.2875C8.90417 15.4792 9 15.7167 9 16V18H12V10.825L8 6.825L4 10.825V18ZM16 19V9.175L12.525 5.7C12.2083 5.38333 12.1333 5.02083 12.3 4.6125C12.4667 4.20417 12.775 4 13.225 4C13.3583 4 13.4917 4.02917 13.625 4.0875C13.7583 4.14583 13.8667 4.21667 13.95 4.3L17.425 7.775C17.6083 7.95833 17.75 8.17083 17.85 8.4125C17.95 8.65417 18 8.90833 18 9.175V19C18 19.2833 17.9042 19.5208 17.7125 19.7125C17.5208 19.9042 17.2833 20 17 20C16.7167 20 16.4792 19.9042 16.2875 19.7125C16.0958 19.5208 16 19.2833 16 19ZM20 19V7.525L18.175 5.7C17.8583 5.38333 17.7833 5.02083 17.95 4.6125C18.1167 4.20417 18.425 4 18.875 4C19.0083 4 19.1417 4.02917 19.275 4.0875C19.4083 4.14583 19.5167 4.21667 19.6 4.3L21.425 6.125C21.6083 6.30833 21.75 6.52083 21.85 6.7625C21.95 7.00417 22 7.25833 22 7.525V19C22 19.2833 21.9042 19.5208 21.7125 19.7125C21.5208 19.9042 21.2833 20 21 20C20.7167 20 20.4792 19.9042 20.2875 19.7125C20.0958 19.5208 20 19.2833 20 19ZM8 13C7.71667 13 7.47917 12.9042 7.2875 12.7125C7.09583 12.5208 7 12.2833 7 12C7 11.7167 7.09583 11.4792 7.2875 11.2875C7.47917 11.0958 7.71667 11 8 11C8.28333 11 8.52083 11.0958 8.7125 11.2875C8.90417 11.4792 9 11.7167 9 12C9 12.2833 8.90417 12.5208 8.7125 12.7125C8.52083 12.9042 8.28333 13 8 13Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifamiliare);
export default __webpack_public_path__ + "static/media/bifamiliare.baeba7309f681d6f5a45ea97db5a0949.svg";
export { ForwardRef as ReactComponent };